import { catalogFieldsQuery } from './getCatalog'
import { gql } from './gql'

/**
 * One page of the catalog, for a category or for all of them.
 *
 * `GET_CATALOG` exists already and cannot do this job: it also selects
 * `getTotalPromotions`, because it is the document that boots the home reels.
 * Paging the grid through it would re-fetch every storefront-wide promotion on
 * every scroll. `GET_INITIAL_CATALOG_VALUES` is worse — it would re-fetch the
 * cart and the session too.
 *
 * So this is the browse document: the products, a category to narrow them, and
 * a page. The first page still arrives with the boot query; this is what the
 * second one, and the category the shopper taps, go through.
 */
export const GET_CATALOG_PAGE = gql`
  query CatalogPage(
    $storefrontName: String!
    $sessionUid: String!
    $categoryName: String
    $pagination: PaginationInput
  ) {
    catalog(
      storefrontName: $storefrontName
      sessionUid: $sessionUid
      category: $categoryName
      pagination: $pagination
    ) {
      ${catalogFieldsQuery}
    }
  }
`
